import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, inject, Inject, input, Input, OnInit, PLATFORM_ID, Renderer2, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { debounceTime, Observable, filter, share, startWith, takeUntil, switchMap } from 'rxjs';
import { AcvisService } from '@app/services/acvis.service';
import { CarrentFilters } from '@app/models/carrent/CarrentFilters';
import { CarrentFiltersService } from '@app/services/carrentfilters.service';
import { MediaService } from '@app/services/media.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConnectedPosition } from '@angular/cdk/overlay';
@Component({
    selector: 'app-city',
    templateUrl: './city.component.html',
    styleUrls: ['./city.component.scss'],
    standalone: false
})
export class CityComponent implements OnInit {
    mode = input<string>('');
    isBrowser = signal<boolean>(false);
    ziel = input<string>('Anmietungs und Rückgabeort');
    showModal = signal<boolean>(false);
    focus = signal<boolean>(false);
    zielText = signal<string>('Beliebig');
    searchObj: Observable<any>;
    mySearchControl = new FormControl();

    destroyRef = inject(DestroyRef);

    overlaypos: ConnectedPosition[] = [
        {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
        }
    ];


    defaultdatas = [
        {
            code: 'PMI',
            name: 'Mallorca',
            country: { code: 'ES', name: 'Spanien' },
            type: 1
        },
        {
            code: 'IBZ',
            name: 'Ibiza',
            country: { code: 'ES', name: 'Spanien' },
            type: 1
        },
    ];

    constructor(
        protected mediaService: MediaService,
        protected cdr: ChangeDetectorRef,
        protected render: Renderer2,
        protected acvisService: AcvisService,
        protected carrentFilterService: CarrentFiltersService,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        this.initSearchChange();
        this.initFilterSub();
    }

    initFilterSub() {
        this.carrentFilterService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((filter: CarrentFilters) => {
            if (filter?.arrivalAirportList?.name?.length > 0) {
                if (this.zielText() !== filter.arrivalAirportList.name) {
                    this.zielText.set(filter.arrivalAirportList.name + ' (' + filter.arrivalAirportList.code + ')');
                }
            } else {
                this.zielText.set('Beliebig');
            }
            this.cdr.detectChanges();
        });
    }

    initSearchChange() {
        const filterShare = this.mySearchControl.valueChanges.pipe(
            startWith(''),
            debounceTime(100),
            filter(value => (typeof value === 'string' && value?.length > 0)),
            share()
        );

        this.searchObj = filterShare.pipe(
            switchMap(value => this.acvisService.request({
                searchValue: value,
                inAll: true
            }, 'airoportListCompletions'))
        );
    }

    async removeAllSelected(ev) {
        ev.stopPropagation();
        this.zielText.set('Beliebig');
        this.mySearchControl.setValue('');
        this.carrentFilterService.arrivalAirportList(null, this.mode);
    }

    openModal() {
        this.showModal.set(true);
        this.focus.set(true);
    }

    openModalMobile(ev) {
        // this.render.addClass(document.body, 'model-open');
        ev?.stopPropagation();
        this.showModal.set(true);
        this.focus.set(true);
    }

    closeModal() {
        this.showModal.set(false);
        this.mySearchControl.setValue('');
    }

    closeModalMobile() {
        this.showModal.set(false);
        // this.render.removeClass(document.body, 'model-open');
        this.cdr.detectChanges();
    }


    clearText() {
        this.mySearchControl.setValue('');
        this.focus.set(false);
        setTimeout(() => {
            this.focus.set(true);
        }, 50);
    }

    selectValue(item) {
        if (item.type === -1) {
            this.zielText.set('Beliebig');
            this.showModal.set(false);
            this.mySearchControl.setValue('');
            this.carrentFilterService.arrivalAirportList(null, this.mode);
        } else {
            this.zielText.set(item?.name + ' (' + item?.code + ')');
            this.showModal.set(false);
            this.mySearchControl.setValue('');
            this.carrentFilterService.arrivalAirportList({
                name: item.name,
                code: item.code
            }, this.mode);
        }
    }
}
